import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Question from "../../../images/icons/question.svg";
import { Button, Grid, Modal } from "@material-ui/core";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 320,
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.24)",
    outline: "none",
    borderRadius: 8,
    padding: theme.spacing(2, 4, 3),
  },
  accept: {
    background: "#E5E5E5",
    color: "#7EBDCE",
    marginRight: "5%",
    "&:hover": {
      background: "#E5E5E5",
    },
  },
  cancel: {
    background: "#7EBDCE",
    color: "white",
    "&:hover": {
      background: "#7EBDCE",
    },
  },
  text: {
    fontSize: 15,
    fontFamily: "Roboto",
    color: "#545353",
    textAlign: "center",
    margin: "25px 20px",
  }
}));

const ModalRepresentativesExpenses = ({
  open,
  handleClickWithExpenses,
  handleClickCloseExpensives
}) => {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);

  const bodyModal = (
    <div style={modalStyle} className={classes.paper}>
        <img src={Question} alt="" style={{ width: "30%" }} />
        
      <p className={classes.text}>
      ¿Desea agregar gastos de representación al certificado laboral?
      </p>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <>  
            <Grid container>
              <Grid container>
                <Button
                  className={classes.cancel}
                  style={{width: 340, marginBottom: 10}}
                  type="submit"
                  variant="contained"
                  color="secondary"
                  onClick={()=> handleClickWithExpenses('yes')}
                >
                  Generar con gastos de representación
                </Button>
              </Grid>
              <Grid container>
                <Button
                  className={classes.cancel}
                  style={{width: 340, marginBottom: 10}}
                  type="submit"
                  variant="contained"
                  color="secondary"
                  onClick={()=> handleClickWithExpenses('no')}
                >
                  Generar sin gastos de representación
                </Button>
              </Grid>
              <Grid container>
                <Button
                  className={classes.accept}
                  style={{width: 340, marginRight: 0}}
                  type="button"
                  variant="contained"
                  onClick={handleClickCloseExpensives}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </>
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        style={{ textAlign: "center" }}
        open={open}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {bodyModal}
      </Modal>
    </div>
  );
};

export default ModalRepresentativesExpenses;
